import { Form } from 'react-bootstrap';

function SelectWithOther({
  name,
  value,
  otherName,
  otherValue = '',
  options = [],
  onChange,
  disabled = false,
  placeholder = 'Select...',
  otherPlaceholder = 'Please specify',
  required = false,
}) {
  return (
    <>
      <Form.Select
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
      >
        <option value="">{placeholder}</option>
        {options.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </Form.Select>
      {value === 'Other' && (
        <Form.Control
          className="mt-2"
          type="text"
          name={otherName}
          value={otherValue}
          onChange={onChange}
          placeholder={otherPlaceholder}
          disabled={disabled}
        />
      )}
    </>
  );
}

export default SelectWithOther;
